import m from "../../../../geodata/es2015/region/usa/mdHigh";
window.am4geodata_region_usa_mdHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/mdHigh.js
// module id = null
// module chunks = 